import LoginPopup from "./LoginPopup.js";
import { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import "../winningVouchers.css";

const AgentLogin = () => {
  const navigate = useNavigate();

  useEffect(() => {
    document.title = "U-Winn || Agent Login";
    const token = sessionStorage.getItem("AGENT-TOKEN");
    const user = JSON.parse(sessionStorage.getItem("AGENT-ADMIN-INFO") || "{}");
    if (token && user?._id) {
      navigate("/voucher-list", { replace: true });
    }
  }, [navigate]);

  const handleLoginSuccess = () => {
    navigate("/voucher-list");
  };

  return (
    <div className="agent-login-page">
      <div className="agent-login-card">
        <div className="agent-login-brand">
          <div className="agent-login-brand__icon">
            <span>U</span>
          </div>
          <h1>Agent Portal</h1>
          <p>Sign in to manage assigned winning vouchers</p>
        </div>
        <LoginPopup
          embedded
          open={true}
          onClose={() => {}}
          onLoginSuccess={handleLoginSuccess}
        />
      </div>
    </div>
  );
};

export default AgentLogin;